module.exports = __webpack_public_path__ + "static/media/RA7.a324f83e.gif";